import React from 'react';
import {
  Button, IconFeatured, Modal,
} from 'gatorcomponents';
import * as Styles from './WhatIsCdnModal.styles';

const WhatIsCdnModal = ({
  onClose,
  title = 'title',
  description = 'description',
  items = [
    {
      icon: 'IconCdn',
      featureBackground: 'attentionPure',
      iconSecondaryColor: 'attentionUltraLight',
      title: 'title',
      description: 'description',
    },
  ],
  cta = 'Ok',
}) => (
  <Modal
    onClose={onClose}
    title={title}
    maxWidth={960}
    maxHeight={564}
  >
    <Styles.Description>{description}</Styles.Description>

    <Styles.CardsWrapper>
      {items.map(item => (
        <Styles.Card>
          <IconFeatured
            icon={item.icon}
            backgroundColor={item.featureBackground}
            secondaryColor={item.iconSecondaryColor}
          />

          <Styles.CardTitle>
            {item.title}
          </Styles.CardTitle>

          <Styles.CardDescription>
            {item.description}
          </Styles.CardDescription>
        </Styles.Card>
      ))}
    </Styles.CardsWrapper>

    <Styles.ButtonWrapper>
      <Button
        testId="what-is-cdn-modal-button"
        onClick={onClose}
        label={cta}
        size="large"
      />
    </Styles.ButtonWrapper>

  </Modal>
);
export default WhatIsCdnModal;
